export async function promptAndSaveFile(url: string, filename?: string): Promise<void> {
  const safeName = filename && filename.trim() ? filename.trim() : "download";
  const electronAPI = (window as any)?.electronAPI;

  if (electronAPI?.saveFileDialog && electronAPI?.saveFile) {
    const savePath: string | null = await electronAPI.saveFileDialog({
      title: "Save file",
      defaultPath: safeName,
    });
    if (!savePath) return;

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to download file: ${response.status} ${response.statusText}`);
    }
    const data = await response.arrayBuffer();
    await electronAPI.saveFile(savePath, data);
    return;
  }

  const link = document.createElement("a");
  link.href = url;
  link.download = safeName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
